export default {
  name: 'logout',
  path: '/logout',
  loadComponent: () => import('./index')
};
